export default __webpack_public_path__ + "static/media/MurderEverything-Mastered1.fc8a7471.mp3";